import React, { Component } from 'react';
import ScrollToNext from '../ScrollToNext/ScrollToNext';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import * as actions from '../../store/actions';
import './SectionThree.css';
import { Row, Col } from 'antd';
import { getLocale } from '../../utils/locale';

class SectionThree extends Component {

  toggleRegistration = () => {
    var countryCode = getLocale().split('-')[1];

    if(countryCode === 'id'){
    this.props.openPopUp('PopUpIDRMarketClosure')
    }
    else{
    this.props.openPopUp('Registration')
    }
  }
  backgroundImage(lang) {
    const locale = lang.split('-')[0];
    const localePath = lang.split('-')[1];
    switch(locale){
      case 'zh' : return 'CN';
      case 'th' : return locale.toUpperCase();
      case 'id' : return locale.toUpperCase();
      case 'vi' : return 'VN';
      default: return 'EN';
    };
  }

  render() {
    return (
      <div className="section-content">
        <div className='section-three'>
          <div className="section-three-content">
            <Row type='flex'>
              <Col xs={24} className="step-title">
                {/* <img className={"section3-details-" + this.backgroundImage(getLocale())} alt=" "/> */}
                <div className={"section3-details-" + this.backgroundImage(getLocale())} />
              </Col>
            </Row>
          </div>
          <div className="dual-tone-container">
            <div>
            </div>
          </div>
        </div>
        <ScrollToNext pageSelector=".section-four" />
      </div>
    );
  }
};

const mapStateToProps = state => {
  return {
  };
};

const mapDispatchToProps = dispatch => {
  return {
    openPopUp: (type) => dispatch(actions.openPopUp(type))
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SectionThree)
);